export const isNewGym = (dateGymAdded: Date): boolean => {
  const daysAgoClassedAsNew = 60;
  const dateAdded = new Date(dateGymAdded);
  const today = new Date();
  const aDayInUnix = 1000 * 3600 * 24;

  const differenceInUnix = today.getTime() - dateAdded.getTime();
  const differenceInDays = Math.round(differenceInUnix / aDayInUnix);

  return differenceInDays <= daysAgoClassedAsNew;
};
